(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('courseService', courseService);

    function courseService() {
        var service = {
        };
        return service;
    }
})();